module.exports = __webpack_public_path__ + "img/symbol_2.cfba9402.png";